module.exports = __webpack_public_path__ + "img/1506816890.c8a42d68.jpg";